<template>
  <div
    class="dropdown"
  >
    <button
      class="btn border-0 bg-transparent d-flex align-items-center gap-2"
      type="button"
      id="dropdownLang"
      ref="dropdownLang"
      data-bs-toggle="dropdown"
      @click="dropdown.toggle()"
      aria-expanded="false"
    >
      <div class="mb-1">
        <country-flag
          :country="$i18n.locale == 'en' ? 'gb' : $i18n.locale"
          size="normal"
          :rounded="true"
        />
      </div>
      <span
        class="d-inline"
        v-if="showHumanLang"
      >
        {{ humanLang }}
      </span>
    </button>
    <ul
      :class="`dropdown-menu ${rightAlignNav ? 'dropdown-menu-end' : ''}`"
      aria-labelledby="dropdownLang"
    >
      <li>
        <span
          :class="`dropdown-item ${$i18n.locale === 'de' ? 'active' : ''}`"
          @click="setLang('de')"
        >
          <country-flag
            country="de"
            size="small"
          />
          Deutsch
        </span>
      </li>
      <li>
        <span
          :class="`dropdown-item ${$i18n.locale === 'en' ? 'active' : ''}`"
          @click="setLang('en')"
        >
          <country-flag
            country="gb"
            size="small"
          />
          English
        </span>
      </li>
      <li>
        <span
          :class="`dropdown-item ${$i18n.locale === 'fr' ? 'active' : ''}`"
          @click="setLang('fr')"
        >
          <country-flag
            country="fr"
            size="small"
          />
          Français
        </span>
      </li>
      <li>
        <span
          :class="`dropdown-item ${$i18n.locale === 'es' ? 'active' : ''}`"
          @click="setLang('es')"
        >
          <country-flag
            country="es"
            size="small"
          />
          Español
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
  import CountryFlag from "vue-country-flag-next";
  import {Dropdown} from "@comlinedev/bootstrap5";
  import {mapGetters} from "vuex";
  import {auth, firestore} from "../../plugins/firebase";
  import {setDoc, doc} from "firebase/firestore";

  export default {
    name: "LangDropdown",
    components: {
      CountryFlag,
    },
    computed: {
      ...mapGetters({
        user: "user",
      }),
      humanLang() {
        switch (this.$i18n.locale) {
          case "de":
            return "Deutsch";
          case "en":
            return "English";
          case "fr":
            return "Français";
          case "es":
            return "Español";
        }
        return this.$i18n.locale;
      },
    },
    data() {
      return {
        dropdown: null,
      };
    },
    props: {
      showHumanLang: {
        type: Boolean,
        default: true,
      },
      rightAlignNav: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      setLang(lang) {
        this.$i18n.locale = lang;

        if (auth.currentUser) {
          auth.languageCode = lang;
          const docRef = doc(firestore, "userLang", auth.currentUser.uid);
          setDoc(docRef, { lang }, { merge: true });
        }

        localStorage.setItem("clgmbh-portal-lang", lang);
      },
    },
    mounted() {
      this.dropdown = new Dropdown(this.$refs.dropdownLang);
    },
  };
</script>
